import gql from 'graphql-tag';

export const GET_ALL_NEWS = gql`
  query getAllNews {
    listPosts(first: 20, page: 1, sort: { field: "published_at", order: DESC }) {
      data {
        id
        category_id
        title
        slug
        post_content
        published_at
        seo_title
        seo_description
        seo_image
        data
        post_introduction
        is_pinned
        image_url
        url_text
        url_link
        user {
          id
          name
          avatar
        }
      }
    }
  }
`;

export const GET_NEWS_CATEGORY_TITLE = gql`
  query CategoryById {
    listBlogCategories {
      id
      title
      slug
    }
  }
`;

export const GET_NEWS_BY_ID = gql`
  query NewsById($id: ID!) {
    getBlogPost(id: $id) {
      id
      user {
        id
        avatar
        name
        email
        tenant_id
      }
      category_id
      title
      slug
      post_content
      published_at
      seo_title
      seo_description
      seo_image
      data
      post_introduction
      is_pinned
      image_url
      url_text
      url_link
    }
  }
`;
